module.exports = __webpack_public_path__ + "img/body-1.ae915be2.png";